import type { SupportedRepubName } from './types';

export type TrendsConfig = {
  defaultEventDisplayName: string;
  last10: string;
  last20: string;
  last5: string;
};

/**
 * Trends configurations for each republic
 */
export const TRENDS_CONFIGS = {
  GZ: {
    // TODO: Revert to 'Serie A' after World Cup 2026
    defaultEventDisplayName: 'World Cup 2026',
    last5: 'Ultime 5',
    last10: 'Ultime 10',
    last20: 'Ultime 20',
  },
  OC: {
    // TODO: Revert to 'EPL' after World Cup 2026
    defaultEventDisplayName: 'World Cup 2026',
    last5: 'Last 5',
    last10: 'Last 10',
    last20: 'Last 20',
  },
  US: {
    // TODO: Revert to 'NFL' after World Cup 2026
    defaultEventDisplayName: 'World Cup 2026',
    last5: 'Last 5',
    last10: 'Last 10',
    last20: 'Last 20',
  },
  WS: {
    // TODO: Revert to 'All' after World Cup 2026
    defaultEventDisplayName: 'World Cup 2026',
    last5: 'Last 5',
    last10: 'Last 10',
    last20: 'Last 20',
  },
  // ES: {
  //   defaultEventDisplayName: 'All',
  //   last5: 'Últimos 5',
  //   last10: 'Últimos 10',
  //   last20: 'Últimos 20',
  // },
} satisfies Record<SupportedRepubName, TrendsConfig>;
